<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      append-to-body
      class="createSaleOrderDialog"
      title="生产订单"
      width="297mm"
      top="10vh">
    <div id="content">
      <div v-for="(form,index) in productionOrderList" :key="index" class="dataList" style="margin-bottom: 20px">
        <div class="qrCodeBox">
          <svg :id="'qrCode'+form.orders"/>
          <div style="flex: 1;">
            <div class="title">新时达工控技术(杭州)有限公司</div>
            <div class="title smallTitle">{{printType === 1 ? '生产工单' : '生产领料单'}}</div>
          </div>
        </div>
        <el-descriptions border :column="3" :label-style="{'word-break': 'keep-all'}">
          <el-descriptions-item label="生产工单号">{{form.orders}}</el-descriptions-item>
          <el-descriptions-item label="创建日期">{{form.addDate}}</el-descriptions-item>
          <el-descriptions-item label="工单类型">{{form.orderTypeName}}</el-descriptions-item>
          <el-descriptions-item label="规格型号">{{form.specification}}</el-descriptions-item>
          <el-descriptions-item label="物料编号">{{form.materialNo}}</el-descriptions-item>
          <el-descriptions-item label="物料描述">{{form.materialDescription}}</el-descriptions-item>
          <el-descriptions-item label="工单数量">{{form.orderNum}}</el-descriptions-item>
          <el-descriptions-item label="计划开工时间">{{form.productStart}}</el-descriptions-item>
          <el-descriptions-item label="计划完工时间">{{form.productEnd}}</el-descriptions-item>
          <el-descriptions-item label="客户编号">{{form.sapCustomerNo}}</el-descriptions-item>
          <el-descriptions-item label="销售凭证">{{form.sapSalesOrderNo}}</el-descriptions-item>
          <el-descriptions-item label="订单优先级">
            <span v-if="form.orderPriority === 'B'">正常</span>
            <span v-if="form.orderPriority === 'A'">紧急</span>
          </el-descriptions-item>
          <el-descriptions-item label="销单备注">{{form.sapSalesOrderNote}}</el-descriptions-item>
          <el-descriptions-item label="工单备注">{{form.sapNote}}</el-descriptions-item>
        </el-descriptions>
        
        <!-- 使用原生table标签替换el-table -->
        <table
            class="print-table"
            width="100%"
            border="1"
            cellspacing="0"
            cellpadding="5">
          <thead>
            <tr>
              <th width="50" style="text-align: center;">序号</th>
              <th width="120" style="text-align: center;">物料编号</th>
              <th width="102" style="text-align: center;">旧料号</th>
              <th width="180" style="text-align: center;" class="material-name-col">物料名称</th>
              <th width="130" style="text-align: center;">规格型号</th>
              <th width="80" style="text-align: center;">仓位</th>
              <th width="110" style="text-align: center;">小仓位</th>
              <th width="70" style="text-align: center;">库存</th>
              <th width="92" style="text-align: center;">需求数量</th>
              <th width="60" style="text-align: center;">单位</th>
              <th style="text-align: center;">备注</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, idx) in form.details" :key="idx">
              <td style="text-align: center;">{{idx + 1}}</td>
              <td style="text-align: center;">{{item.materialCode}}</td>
              <td style="text-align: center;">{{item.mappingMaterialNo}}</td>
              <td style="text-align: left;" class="material-name-col">{{item.materialDescription}}</td>
              <td style="text-align: center;">{{item.specification}}</td>
              <td style="text-align: center;">{{constant.locationNo[item.positionNo]}}</td>
              <td style="text-align: center;">{{item.locationNo}}</td>
              <td style="text-align: center;">{{item.locationNumber}}</td>
              <td style="text-align: center;">{{item.requirementNum}}</td>
              <td style="text-align: center;">{{item.unit}}</td>
              <td style="text-align: left;">{{item.note}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="print">打印</el-button>
    </span>
  </el-dialog>
</template>

<script>
  // import QRCode from "qrcodejs2";
  import barCode from "jsbarcode";
  import constants from "@/util/constants";
  import constant from "@/util/constant";

  export default {
    name: "ProductionOrderPrint",
    components: {},
    data() {
      return {
        constant,
        constants,
        pkid: "",
        activeName: "deliverySlipInfo", // 当前标签页
        dialogVisible: false,
        submitLoading: false,
        edit: 0,
        productionOrderList: [],
        printType: 1, // 1: 生产单打印 2: 生产领料打印
        printPkid: "",
        ruleValidate: {
          demandQuantity: {required: true, message: "请选择数量"},
          requirement: {required: true, message: "请选择溯源需求"},
        },
      };
    },
    methods: {
      open(ids, printType) {
        this.dialogVisible = true;
        this.printType = printType;
        this.printPkid = ids;
        this.getData(ids);
      },
      getData(ids) {
        this.productionOrderList = [];
        // let params = {ids: ids};
        this.$http.put("basic", "sapProductionOrders/getByIds", ids).then((resp) => {
          this.productionOrderList = resp.data;
          this.$nextTick(() => {
            this.productionOrderList.forEach(resp => {
              document.getElementById("qrCode" + resp.orders).innerHTML = "";
              this.bindQRCode(resp);
            });
          });
        });
      },
      formatDateTime(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      },
      
      bindQRCode(row) {
        let text = row.orders;
        new barCode(
          "#qrCode" + text, text,
          {
            displayValue: true, // 是否在条形码下方显示文字
            format: "CODE128",
            height: 40,
          },
        );
        // new QRCode(document.getElementById("qrCode" + row.orders), {
        //   text: text,
        //   width: 100,
        //   height: 100,
        //   colorDark: "#333333", //二维码颜色
        //   colorLight: "#ffffff", //二维码背景色
        //   correctLevel: QRCode.CorrectLevel.L,//容错率，L/M/H
        // });
      },
      print() {
        document.body.innerHTML = document.getElementById("content").parentNode.innerHTML;
        // 执行打印
        window.print();
        // 如果是生产领料打印，需要更新数据库
        if(this.printType === 2) {
          this.$http
            .put("basic", "sapProductionOrders", {pkId: this.printPkid[0], wareHousePrint: true, wareHousePrintDate: this.formatDateTime(new Date())})
            .finally(() => {
              window.location.reload();
            });
        }
        return false;
      },
    },
  };
</script>

<style lang="scss" scoped>
.qrCodeBox {
  border: 1px solid #000;
  display: flex;
}

.title {
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-weight: 700;
  font-size: 18pt;
  color: #000;
  border-bottom: 1px solid #000;
}

.smallTitle {
  font-size: 18pt;
  border-bottom: none;
}

/* 表格样式设置 */
.print-table {
  width: 100%;
  font-size: 12pt;
  font-family: "Microsoft YaHei", "SimHei", "Arial", sans-serif;
  color: #000;
  border-collapse: collapse;
  border: 1px solid #000;
}

.print-table th,
.print-table td {
  font-size: 12pt;
  color: #000;
  border: 1px solid #000;
  padding: 5px;
  word-wrap: break-word;
  word-break: break-all;
}

.print-table th {
  background-color: #f5f5f5;
  font-weight: bold;
  text-align: center;
  vertical-align: middle;
}

/* 物料名称列固定宽度100px，超出显示省略号 */
.material-name-col {
  width: 120px;
  max-width: 120px;
  min-width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media print {
  @page {
    margin: 15mm 10mm 15mm 10mm;
  }
  .el-dialog__header, .el-dialog__footer{
    display: none;
  }
  
  /* 基础布局修复 */
  body {
    margin: 0;
    padding: 0;
  }
  
  #content {
    width: 100%;
    max-width: 100%;
    margin: 0;
    padding: 0;
    display: block;
  }
  
  .dataList {
    margin-bottom: 15px;
    width: 100%;
    display: block;
    /* 只在必要时才分页 */
    break-inside: avoid;
  }
  
  .smallTitle {
    font-size: 18pt;
    page-break-after: avoid;
  }
  
  /* 表格打印样式 - 优化分页规则 */
  .print-table {
    width: 100%;
    font-size: 12pt;
    color: #000;
    border-collapse: collapse;
    /* 移除fixed布局，可能导致内容被错误分页 */
  }
  
  .print-table th,
  .print-table td {
    font-size: 12pt;
    color: #000;
    border: 1px solid #000;
    padding: 3px;
    /* 移除强制不分页规则，避免内容被强制拉伸 */
    break-inside: avoid;
  }
  
  /* 物料名称列打印时固定宽度120px */
  .material-name-col {
    width: 120px;
    max-width: 120px;
    min-width: 120px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .print-table th {
    background-color: #fff !important;
    font-weight: bold;
    text-align: center;
    vertical-align: middle;
    page-break-after: avoid;
  }
  
  /* 只在表格内部需要时使用table显示 */
  .print-table tbody {
    display: table-row-group;
  }
  
  .print-table thead {
    display: table-header-group;
  }
  
  .print-table tr {
    /* 移除强制不分页，让浏览器自然分页 */
    page-break-inside: auto;
    page-break-after: auto;
  }
}

/* 修复el-descriptions在打印时的显示 */
::v-deep .el-descriptions--mini{
  font-size: 12pt;
  font-family: "Microsoft YaHei", "SimHei", "Arial", sans-serif; // 使用更清晰的中文字体
  font-weight: normal; // 确保字体粗细适中
  color: #000; // 确保黑色打印
  border-color: #000;
}
::v-deep .el-descriptions-item__label.is-bordered-label{
  font-family: "Microsoft YaHei", "SimHei", "Arial", sans-serif; // 使用更清晰的中文字体
  font-weight: normal; // 确保字体粗细适中
  color: #000; // 确保黑色打印
  border-color: #000;
}
::v-deep .el-descriptions__body{
  font-family: "Microsoft YaHei", "SimHei", "Arial", sans-serif; // 使用更清晰的中文字体
  font-weight: normal; // 确保字体粗细适中
  color: #000; // 确保黑色打印
  border-color: #000;
}
::v-deep .el-descriptions--mini.is-bordered .el-descriptions-item__cell{
  padding: 5px;
  border-color: #000;
}
::v-deep .el-descriptions .is-bordered .el-descriptions-item__cell{
  border-color: #000;
}
</style>